module.exports = __webpack_public_path__ + "assets/7b483cc5a3190ffea4b517442e8e0ead.png";